import {
  getAllCourses,
  getAllActivities,
  postAccountVerify,
  bookCourse,
  checkAvailability,
  bookActivity,
} from "@/api/tac";

export default {
  getAllCourses({ commit }) {
    commit("REQUEST_ALL_COURSES");

    const from = new Date().toISOString();
    const upcomingSunday = new Date();
    upcomingSunday.setDate(new Date().getDate() + (14 - new Date().getDay()));
    upcomingSunday.setHours(23, 0, 0, 0);
    const to = upcomingSunday.toISOString();

    return getAllCourses({
      from,
      to,
    })
      .then((response) => {
        commit("SUCCESS_ALL_COURSES", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to get all courses:", err);
        commit("FAILED_ALL_COURSES");
      });
  },
  getAllActivities({ commit }) {
    commit("REQUEST_ALL_ACTIVITIES");

    const from = new Date().toISOString();
    const upcomingSunday = new Date();
    upcomingSunday.setDate(new Date().getDate() + (14 - new Date().getDay()));
    upcomingSunday.setHours(23, 0, 0, 0);
    const to = upcomingSunday.toISOString();

    return getAllActivities({
      from,
      to,
    })
      .then((response) => {
        commit("SUCCESS_ALL_ACTIVITIES", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to get all activities:", err);
        commit("FAILED_ALL_ACTIVITIES");
      });
  },
  checkAvailability({ commit }, { activityId, date, language }) {
    commit("REQUEST_CHECK_AVAILABILITY");
    return new Promise((resolve, reject) => {
      checkAvailability({ activityId, date, language })
        .then((response) => {
          commit("SUCCESS_CHECK_AVAILABILITY");
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error("failed to check availability:", err);
          commit("FAILED_CHECK_AVAILABILITY");
          reject(err);
        });
    });
  },
  bookActivity(
    { commit },
    { activityId, date, start, end, schedulingFor, notes, language }
  ) {
    commit("REQUEST_BOOK_ACTIVITY");
    return new Promise((resolve, reject) => {
      bookActivity({
        activityId,
        date,
        start,
        end,
        schedulingFor,
        notes,
        language,
      })
        .then((response) => {
          commit("SUCCESS_BOOK_ACTIVITY", response);
          resolve(response);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error("failed to book activity:", err);
          commit("FAILED_BOOK_ACTIVITY");
          reject(err);
        });
    });
  },
  postAccountVerify({ commit, rootState }) {
    commit("REQUEST_TOKEN");
    const payload = {
      lastname: rootState.session.authResult?.checkin[0]?.last_name || "",
      roomNumber: rootState.session.authResult.room || "",
      reservationId: "",
      confirmationId: "",
      accountName: "",
      propertyId: rootState.session.propertyId || "",
    };
    return new Promise((resolve, reject) => {
      postAccountVerify(payload)
        .then((response) => {
          if (response.code == 200) {
            commit("SUCCESS_TOKEN", response.token);
            resolve();
          } else {
            commit("FAILED_TOKEN");
            reject();
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error("failed to get token:", err);
          commit("FAILED_TOKEN");
          reject(err);
        });
    });
  },
  bookCourse({ commit }, { courseId, language, numberOfPersons }) {
    commit("REQUEST_BOOK_COURSE");
    bookCourse({ courseId, language, numberOfPersons })
      .then((response) => {
        commit("SUCCESS_BOOK_COURSE", response);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("failed to book course:", err);
        commit("FAILED_BOOK_COURSE");
      });
  },
};
